import { Eye, Pencil } from 'lucide-react';
import { useDraftModeToggle } from '../hooks/useDraftMode';
import { useIsReadOnly } from '../contexts/ReadOnlyContext';
import { Button } from './ui/button';

/**
 * Explains why a page can't be edited and offers a one-click way out.
 * Renders nothing when the surrounding region is editable.
 */
export function ReadOnlyBanner({ message }: { message?: string }) {
  const readOnly = useIsReadOnly();
  const toggleDraftMode = useDraftModeToggle();

  if (!readOnly) return null;

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 w-full px-4 md:px-6 py-2 border-b border-border bg-muted/50 flex-shrink-0">
      <div className="flex items-center gap-2 min-w-0 text-sm text-muted-foreground">
        <Eye className="h-4 w-4 flex-shrink-0" />
        <span>{message ?? 'Production mode — read only. Switch to Develop mode to make changes.'}</span>
      </div>
      <Button size="sm" variant="outline" className="gap-2" onClick={() => toggleDraftMode('read-only-banner')}>
        <Pencil className="h-4 w-4" />
        Edit
      </Button>
    </div>
  );
}
